// AUTO-GENERATED bei jedem Build — nicht manuell editieren.
// Wird vor 'vite build' von scripts/write-build-info.mjs überschrieben.
export const BUILD_TIME = '2026-09-24 13:51';
export const BUILD_VERSION = '6.0.0';
export const PRODUKT_VERSION = 'V6.0';
